import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useTopLevelDomain} from '../hooks/useTopLevelDomain';
import {useTopLevelDomainsSelection} from '../hooks/useTopLevelDomainsSelection';
import {useEditPageTools} from '../hooks/useEditPageTools';

export const EditPage = () => {

    const {id: componentId} = useParams();

    if (typeof componentId === 'undefined') {
        throw new Error('componentId is required parameter');
    }

    const {
        record: component,
        fetchRecord,
        updateRecord,
    } = useTopLevelDomain(componentId);

    const {handleClearSelection} = useTopLevelDomainsSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
        fetchRecord();
        // FNP-960: deliberately mount-only. The callback is recreated on
        // every render, so adding it to the deps would re-fire in a loop.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    if (!component) {
        return <PlatformLoader message='Loading application...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={component.name ? component.name : component.id}
            pageNavigation={<EditPageNavigation component={component}/>}
            tools={tools}
        >


            {mode === 'view' ?

                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 4
                    }}>
                        <Profile record={component}/>
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 8
                    }}>
                        <SimplePageContentWrapper>
                            something
                        </SimplePageContentWrapper>
                    </Grid.Col>
                </Grid>


                :
                <RecordForm
                    record={component}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};
